import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import { useTheme } from './useTheme';
import { useScreen } from './useScreen';
import { supabase } from './supabaseClient';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)', triGrad:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

const SALES_TYPES = [
  { value:'productos', label:'Productos físicos', desc:'comida, ropa, artesanías', emoji:'📦' },
  { value:'boletos', label:'Boletos o entradas', desc:'eventos, carreras', emoji:'🎟️' },
  { value:'rentas', label:'Rentas de espacios', desc:'cabañas, salones', emoji:'🏠' },
  { value:'servicios', label:'Servicios o consultas', desc:'terapias, coaching, diseño', emoji:'🔧' },
  { value:'otro', label:'Otro', desc:'', emoji:'⭐' },
];
const CHANNELS = [
  { value:'redes', label:'Redes sociales', emoji:'📱' },
  { value:'whatsapp', label:'WhatsApp', emoji:'💬' },
  { value:'local', label:'Llegan al local', emoji:'🏪' },
  { value:'referido', label:'Referidos', emoji:'🤝' },
  { value:'web', label:'Página web', emoji:'🌐' },
  { value:'otro', label:'Otro', emoji:'✨' },
];

export default function ProfileGate({ children }) {
  const { user, profile, refreshProfile } = useAuth();
  const t = useTheme();
  const { isMobile } = useScreen();
  const [form, setForm] = useState({ full_name:'', business_name:'', business_type:'', city:'', sales_type:'', sales_channels:[] });
  const [saving, setSaving] = useState(false);

  const needsSetup = profile && !profile.business_name;
  if (!needsSetup) return children;

  const canSave = form.business_name.trim() && form.business_type && form.sales_type;

  const toggleChannel = (ch) => {
    setForm(f => ({ ...f, sales_channels: f.sales_channels.includes(ch) ? f.sales_channels.filter(c=>c!==ch) : [...f.sales_channels, ch] }));
  };

  const save = async () => {
    if (!canSave || saving || !user) return;
    setSaving(true);
    await supabase.from('profiles').update({
      full_name: form.full_name || profile.full_name,
      business_name: form.business_name,
      business_type: form.business_type,
      city: form.city,
      sales_type: form.sales_type,
      sales_channels: form.sales_channels.length > 0 ? form.sales_channels : null,
      updated_at: new Date().toISOString(),
    }).eq('id', user.id);
    await refreshProfile();
    setSaving(false);
  };

  const inp = { width:'100%', padding:'10px 14px', border:'1px solid rgba(255,255,255,0.1)', borderRadius:12, fontSize:14, fontFamily:font, background:'rgba(255,255,255,0.06)', color:'#fff', outline:'none', boxSizing:'border-box' };

  return (
    <>
      {children}
      <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.7)', backdropFilter:'blur(8px)', zIndex:10000, display:'flex', alignItems:'center', justifyContent:'center', overflow:'auto' }}>
        <div style={{ background:'rgba(255,255,255,0.06)', backdropFilter:'blur(30px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:24, padding:isMobile?'1.5rem':'2rem', width:'calc(100vw - 3rem)', maxWidth:460, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
          <div style={{ textAlign:'center', marginBottom:20 }}>
            <div style={{ width:48, height:48, borderRadius:'50%', background:C.triGrad, margin:'0 auto 12px', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 0 20px rgba(93,193,185,0.3)' }}>
              <span style={{ color:'#fff', fontSize:14, fontWeight:600 }}>T&D</span>
            </div>
            <p style={{ fontFamily:serif, fontSize:20, fontWeight:400, margin:'0 0 6px' }}>Personaliza tu escritorio</p>
            <p style={{ fontSize:13, color:t.textSecondary, margin:0 }}>Necesitamos algunos datos para personalizar tu experiencia</p>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:14, marginBottom:20 }}>
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:4 }}>Tu nombre</label>
              <input value={form.full_name} onChange={e=>setForm(f=>({...f,full_name:e.target.value}))} placeholder={profile?.full_name||'Tu nombre'} style={inp}/>
            </div>
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:4 }}>Nombre de tu negocio *</label>
              <input value={form.business_name} onChange={e=>setForm(f=>({...f,business_name:e.target.value}))} placeholder="Ej: Postres Mía" style={inp}/>
            </div>
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:4 }}>Tipo de negocio *</label>
              <select value={form.business_type} onChange={e=>setForm(f=>({...f,business_type:e.target.value}))} style={inp}>
                <option value="">Seleccionar</option>
                <option value="comida">Comida / Bebidas</option>
                <option value="ropa">Ropa / Moda</option>
                <option value="servicios">Servicios</option>
                <option value="tecnologia">Tecnología</option>
                <option value="artesanias">Artesanías</option>
                <option value="belleza">Belleza</option>
                <option value="fitness">Fitness</option>
                <option value="eventos">Eventos</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:4 }}>Ciudad</label>
              <input value={form.city} onChange={e=>setForm(f=>({...f,city:e.target.value}))} placeholder="Ej: CDMX, México" style={inp}/>
            </div>

            {/* Sales type */}
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:6 }}>¿Qué vendes? *</label>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {SALES_TYPES.map(st => (
                  <div key={st.value} onClick={()=>setForm(f=>({...f,sales_type:st.value}))} style={{
                    padding:'10px 14px', borderRadius:12, cursor:'pointer',
                    border:`0.5px solid ${form.sales_type===st.value?C.turquesa:t.border}`,
                    background:form.sales_type===st.value?C.turquesa+'12':'transparent',
                    display:'flex', alignItems:'center', gap:10,
                  }}>
                    <span style={{ fontSize:18 }}>{st.emoji}</span>
                    <div>
                      <p style={{ fontSize:13, fontWeight:500, margin:0 }}>{st.label}</p>
                      {st.desc && <p style={{ fontSize:11, color:t.textSecondary, margin:0 }}>{st.desc}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Sales channels */}
            <div>
              <label style={{ fontSize:12, color:t.textSecondary, display:'block', marginBottom:6 }}>¿Cómo te llegan los clientes?</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                {CHANNELS.map(ch => {
                  const sel = form.sales_channels.includes(ch.value);
                  return (
                    <button key={ch.value} onClick={()=>toggleChannel(ch.value)} style={{
                      padding:'7px 14px', borderRadius:50, fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font,
                      border:`0.5px solid ${sel?C.turquesa:t.border}`,
                      background:sel?C.turquesa+'15':'transparent', color:sel?C.turquesa:t.text,
                    }}>{ch.emoji} {ch.label}</button>
                  );
                })}
              </div>
            </div>
          </div>
          <button className="td-glow-btn" onClick={save} disabled={!canSave||saving} style={{ width:'100%', background:canSave?C.logoGrad:t.border, color:'#fff', border:'none', borderRadius:50, padding:'13px', fontSize:15, fontWeight:500, cursor:canSave?'pointer':'not-allowed', fontFamily:font, opacity:saving?0.6:1 }}>
            {saving ? 'Guardando...' : 'Personalizar mi escritorio'}
          </button>
        </div>
      </div>
    </>
  );
}
